import { assignProductionSource, assignProductionSourceBulk } from "../api/OrderAPIs";

export const PRODUCTION_SOURCES = ["Girabat", "TeePlus", "Printlet"];

export const formatProductionLabel = (source) => {
  if (!source) return null;
  return `Production: ${source}`;
};

export async function copyTextToClipboard(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textArea);
    return ok;
  } catch {
    return false;
  }
}

export async function recordTeePlusCopy(orderIds) {
  const ids = (Array.isArray(orderIds) ? orderIds : [orderIds])
    .map((id) => Number(id))
    .filter((id) => Number.isFinite(id) && id > 0);
  if (!ids.length) return null;

  if (ids.length === 1) {
    return assignProductionSource(ids[0], "TeePlus", "Copied to TeePlus");
  }
  return assignProductionSourceBulk(ids, "TeePlus", "Copied to TeePlus");
}

export async function copyOrderToTeePlus(text, orderIds) {
  const copied = await copyTextToClipboard(text);
  if (!copied) {
    const error = new Error("COPY_FAILED");
    error.code = "COPY_FAILED";
    throw error;
  }
  try {
    await recordTeePlusCopy(orderIds);
  } catch (err) {
    const error = new Error(err.message || "SOURCE_FAILED");
    error.code = "SOURCE_FAILED";
    throw error;
  }
}
